import {
	FETCH_USER_WALL_LIST_REQUEST,
	FETCH_USER_WALL_LIST_SUCCESS,
	FETCH_USER_WALL_LIST_FAILURE
} from "../../constants";

const initialState = {
	data: [],
	loading: false,
	error: null,
};

const userWallPostListReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_USER_WALL_LIST_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case FETCH_USER_WALL_LIST_SUCCESS:
			return {
				...state,
				data: action.payload,
				loading: false,
				error: null,
			};
		case FETCH_USER_WALL_LIST_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null
			};
		default:
			return state;
	}
};

export default userWallPostListReducer;
